import EmployerPendingsUI from '../../../dictionaries/EmployerPendingsUI.dic';
import Ui3DotsMenu from '../../../dictionaries/Ui3DotsMenu.dic';
import addAccountToSourceList from '../../../lib/Account/addAccountToSourceList.fun';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import Definition, {
  ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS,
  ACCOUNT_ACTION__EDIT_JOB,
  ACCOUNT_ACTION__LIST_ENGAGEMENTS,
  ACCOUNT_ACTION__MATCH_JOB
} from '../../../lib/Definition';
import Engagement from '../../../lib/Engagement';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import Job from '../../../lib/Job';
import {
  getJobModel
} from '../../../lib/models/job';
import orderJsonProperties from '../../../lib/Object/orderJsonProperties.fun';
import {
  ROLE__LIMITED_RECRUITER,
  ROLE__TRUSTED_RECRUITER
} from '../../../lib/services/Accounts/Session.lib';
import { COLLECTION__JOBS } from '../../../lib/services/BE/loopback.api';
import {
  compileText
} from '../../../lib/String.lib';
import copyHtml from '../../../lib/tools/copyHtml';
import {
  matchLocation
} from '../../../lib/URL.lib';
import openDialogAccountEmployerSelector from '../../Accounts/Libraries/openDialogAccountEmployerSelector.fun';
import openDialogAccountSelector from '../../Accounts/Libraries/openDialogAccountSelector.fun';
import TriggerWaitingEmployerSummary from '../../Employers/EmployerPendings/TriggerWaitingEmployerSummary';
import {
  openCloseJob
} from '../../Engagements/RecruiterJobUpdates/CloseJob';
import {
  openPreviewRecruiterEmployerUpdates
} from '../../Engagements/RecruiterJobUpdates/PreviewRecruiterEmployerUpdates';
import {
  openPreviewRecruiterJobUpdates
} from '../../Engagements/RecruiterJobUpdates/PreviewRecruiterJobUpdates';
import Button from '../../Layout/Wrappers/Button';
import Typography from '../../Layout/Wrappers/Typography';
import { getControllerSampleJsonData } from '../../Tools/SampleJsonData';
import ActionStarJob from './ActionStarJob';

export const moreMenuOptionsJobs = [
  {
    acl: (job) => (
      Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_JOB }) &&
      NOT(matchLocation(/job\/(create|edit)/i))
    ),
    label: Ui3DotsMenu.Job.edit,
    to: (job) => (`/job/edit/${job.id}`),
  },
  {
    render: (job) => <ActionStarJob jobId={job.id} />,
    acl: (job) => NOT(matchLocation(/jobs/i)),
  },
  {
    acl: (job) => (
      Core.isAdmin({ action: ACCOUNT_ACTION__MATCH_JOB }) &&
      NOT(matchLocation(/\/(create|edit|match)/i))
    ),
    to: job => (`/job/match/${job.id}`),
    label: Ui3DotsMenu.Job.match,
  },
  {
    acl: (job) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    label: Ui3DotsMenu.Job.employerPendings,
    to: (job) => (`/employer/pendings/?employerId=${job.employerId}`),
    target: (job) => '_blank',
  },
  {
    acl: (job) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    label: EmployerPendingsUI.urlGeneratorDialog.title,
    action: (job) => openDialogAccountEmployerSelector({
      employerId: job.employerId
    })
  },
  {
    acl: (employer) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    render: (job, { key, ...props }) => (
      <TriggerWaitingEmployerSummary {...props}
        employerId={job.employerId}
        type='MenuItem'
      />
    )
  },
  {
    acl: job => Core.isAdmin({ action: ACCOUNT_ACTION__LIST_ENGAGEMENTS }),
    label: job => `Engagements Details${job.engagements?.length ? `(${job.engagements.length})` : ''}`,
    action: job => job.openEngagementsDetails(),
  },
  {
    acl: job => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_JOB }),
    label: Ui3DotsMenu.Job.clone,
    action: cloneJob,
  },
  {
    label: 'Copy JD - long',
    action: copyJobLarge
  },
  {
    label: 'Copy JD - short',
    action: copyJobShort
  },
  {
    acl: (job) => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_JOB }),
    label: Ui3DotsMenu.Job.close,
    action: job => openCloseJob({ jobId: job.id }),
  },
  {
    acl: (job) => Core.isAdmin(),
    label: Ui3DotsMenu.Job.previewRecruiterJobUpdates,
    action: job => openPreviewRecruiterJobUpdates({ jobId: job.id }),
  },
  {
    acl: (job) => Core.isAdmin(),
    label: Ui3DotsMenu.Employer.previewRecruiterEmployerUpdates,
    action: ({ employerId }) => openPreviewRecruiterEmployerUpdates({ employerId }),
  },
  {
    acl: (job) => Core.isAdmin(),
    label: Ui3DotsMenu.Job.intakeAttendance,
    action: (job) => openDialogAccountSelector({
      title: Ui3DotsMenu.Job.intakeAttendance,
      where: {
        role: {
          inq: [
            ROLE__TRUSTED_RECRUITER,
            ROLE__LIMITED_RECRUITER
          ]
        }
      },
      onApply: (accountIds) => addAccountToSourceList({
        jobId: job.id,
        accountIds
      }),
    })
  },
  {
    acl: (job) => Core.isAdmin(),
    label: 'Admin only: model view',
    action: (job) => getControllerSampleJsonData().updateState({
      collection: COLLECTION__JOBS,
      jsonDataA: orderJsonProperties({
        data: getJobModel({ extended: true })
      }),
      id: job.id,
    }).then(
      () => setTimeout(
        () => getControllerSampleJsonData().fetchData({ id: job.id }),
        100
      )
    ).catch(globalErrorHandler)
  },
  {
    acl: job => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_JOB }),
    label: (
      <Typography className='c-red'>
        {compileText(Ui3DotsMenu.Common.deleteEntity, {
          ENTITY: matchLocation(/\/(create|edit)/i) ? '' : Ui3DotsMenu.Job.ENTITY
        })}
      </Typography>
    ),
    action: job => deleteJob(job)
  }
];

export function copyJobLarge(job) {
  copyHtml(Job.getPreview(job, 'large'))
    .then((em) => {
      Core.log('Copy email command was successful');
      Core.showSuccess(
        'Copied - Job Description copied for you to paste elsewhere!'
      );
    })
    .catch((ex) => {
      Core.log("Oops, unable to copy");
      Core.showError("Fail copy!");
    })
}

export function copyJobShort(job) {
  copyHtml(Job.getPreview(job, 'short'))
    .then((em) => {
      Core.log('Copy email command was successful');
      Core.showSuccess('Copied - Job Description copied for you to paste elsewhere!');
    })
    .catch((ex) => {
      Core.log("Oops, unable to copy");
      Core.showError("Fail copy!");
    })
}

function getEditJobModel(job) {
  const newJobModel = {};
  Object.keys(getJobModel()).forEach((key) => {
    if (
      typeof job[key] === "boolean" ||
      key === "visaTransfer" ||
      !!job[key]
    ) {
      newJobModel[key] = job[key];
    }
  });
  delete newJobModel.id;
  newJobModel.state = Definition.getId("state", "Draft");
  Core.log({ newJobModel });
  return newJobModel;
}

function cloneJob(job) {
  const model = getEditJobModel({ ...job });
  [
    'createdAt',
    'updatedAt',
    'feedbackLogInterview',
    'feedbackLogResume',
    'examplesOfAccepted',
    'examplesOfRejected',
    'jobDescription',
    'jobDescriptionPublicURL',
    'atsContext',
  ].forEach((key) => {
    delete model[key];
  });
  Job.post(model,
    (response) => Core.go({
      to: `/job/edit/${response.id}`,
      refresh: true
    })
  );
}

function deleteJob(job) {
  Engagement.getWhere({ jobId: job.id }).then(
    engagements =>
      Core.dialog.open({
        title: 'Confirm',
        message: `Delete "${job._name}"${!!engagements.length
          ? ` and ${engagements.length} engagement${engagements.length === 1 ? "" : "s"
          }?`
          : ""
          }`,
        paperStyle: { width: sizes.m6 },
        actions: [
          <Button outlined minW120
            onClick={Core.dialog.close}
          >
            Cancel
          </Button>,
          <Button primary minW120
            onClick={
              ev =>
                Job.delete(job.id,
                  response => {
                    Core.showSuccess(
                      "Job was deleted successfully"
                    );
                    Core.go({
                      to: '/jobs',
                      refresh: true
                    });
                  },
                  error => {
                    if (!!error) {
                      Core.showWarning('Can not delete job. Please contact support.');
                    }
                  }
                )
            }
          >
            Delete
          </Button>

        ]
      })
  )
}